// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { type PFixFieldSet } from '../Fields/PFixFieldSet';

export class MessageProcessorBase {
    public decode (fieldset: PFixFieldSet): any[] {
        throw new Error('Not implemented');
    }
}
